<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sZTucj/tc-custom/9781429941433.jpg?1724876925257" alt="This image is the cover for the book Exiles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Exiles
      </h1>
      <p class="bookDescription body article font2">
        <p>With <i>Exiles</i>, Ron Hansen tells the story of a notorious shipwreck that prompted Gerard Manley Hopkins to break years of "elected silence" with an outpouring of dazzling poetry. <br/><br/>In December 1875 the steamship <i>Deutschland </i>left Bremen, bound for England and then America. On board were five young nuns who, exiled by Bismarck's laws against Catholic religious orders, were going to begin their lives anew in Missouri. Early one morning, the ship ran aground in the Thames and more than sixty lives were lost—including those of the five nuns. <br/><br/>Hopkins was a Jesuit seminarian in Wales, and he was so moved by the news of the shipwreck that he wrote a grand poem about it, his first serious work since abandoning a literary career at Oxford to become a priest. He too would die young, an exile from the literary world. But as Hansen's gorgeously written account of Hopkins's life makes clear, he fulfilled his calling. <br/><br/>Combining a thrilling tragedy at sea with the seeming shipwreck of Hopkins's own life, <i>Exiles </i>joins Hansen's <i>Mariette in Ecstasy </i>(called "an astonishingly deft and provocative novel" by <i>The New York Times</i>) as a novel that dramatizes the passionate inner search of religious life and makes it accessible to us in the way that only great art can.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ron Hansen
      </h2>
      
      <p class="authorDescription body article">Ron Hansen is the author of eight novels, two collections of stories, and a book of essays. He graduated from Creighton University in Omaha and went on to study at the University of Iowa Writers&rsquo; Workshop and Stanford University. His novel <i>Atticus</i> was a finalist for both the National Book Award and the PEN/Faulkner Award. His novel <i>The Assassination of Jesse James by the Coward Robert Ford</i>, also a finalist for the PEN/Faulkner Award, was adapted into a movie starring Brad Pitt and Casey Affleck. Hansen has received fellowships from the National Endowment for the Arts and the Guggenheim Foundation. He lives with his wife, novelist Bo Caldwell, in Northern California, and teaches at Santa Clara University.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Amazon
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7cf800de